<template>
  <div class="shopping">
    <div class="searchBox">
      <div class="search">
        <div class="input">
          <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/sosuo@2x.png" alt="">
          <input type="text" placeholder="办公室刷墙低至27元/㎡">
        </div>
        <div class="btn" @click="search">搜索</div>
      </div>
      <div class="keyword">
        <p>热门搜索：</p>
        <p :class="{orange:item.hot}" v-for="(item,index) in keyArray" :key='index'>{{item.name}}</p>
      </div>
    </div>
    <div class="navbar">
      <div class="container flexCenter">
        <div class="first flexCenter">
          <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/fenlei@2x.png" alt="">
          <div>全部服务分类</div>
        </div>
        <div class="navItem" v-for="item,index in navbar" :key="index" @click="$router.push(item.path)">
          <p>{{item.name}}</p>
          <img v-if="item.hot" src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/HOT@2x.png" alt="">
          <img v-if="item.new" src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/NEWh@2x.png" alt="">
        </div>
      </div>
    </div>
    <div class="container section flex">
      <div class="menu">
        <div class="menuItem" @mouseenter="menuHover(item)" @mouseleave="menuLeave(item)" v-for="item,index in menubar" :key="index">
          <img class="icon" v-if="activeMenu!=item.id" :src="item.icon" alt="">
          <img class="icon" v-else :src="item.select" alt="">
          <p :class="{orange:activeMenu==item.id}">{{item.name}}</p>
          <img class="more" v-if="activeMenu!=item.id" src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/more.png" alt="">
          <img class="more" v-else src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/more1.png" alt="">
          <div class="childmenu" >
            <div class="childItem" v-for="item1,index1 in menuChild" :key="index1">
              <div class="title">{{item1.name}}</div>
              <div class="content">
                <span @click="$router.push('/waiting')" v-for="item2 in item1.text">{{item2}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-container swiperBig">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in banner" :key="index" >
            <img class="img" :src="item.img" alt>
          </div>
        </div>
      </div>
      <div class="user">
        <div class="top box">
          <div class="flexCenter">
            <img  class="avatar" src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/touxiangmr@2x.png" alt="">
            <div class="tips">
              <h3>Hi,欢迎来到智鼎云商城</h3>
              <p>登录立享企业特权</p>
            </div>
          </div>
          <div class="login">登录/注册</div>
        </div>
        <div class="middle box">
          <h3>公告</h3>
          <p>李先生（尾号2908）已下单装修服务</p>
        </div>
        <div class="bottom box">
          <h3>企业会员专享特权</h3>
          <div class="spaceBetween">
            <div class="item" v-for="item,index in profit" :key="index">
              <img :src="item.img" alt="">
              <p>{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <header>
      <div class="line"></div>
      <p>特别推荐</p>
      <div class="line"></div>
    </header>
    <div class="intro spaceBetween container">
      <div class="card" v-for="item,index in special">
        <img :src="item.img" alt="">
        <div class="message">
          <h3>{{item.title}}</h3>
          <div class="line" v-if="index>0"></div>
          <p v-if="index>0">{{item.text}}</p>
          <p v-else style="text-align:center">{{item.text}}</p>
        </div>
      </div>
    </div>
    <header>
      <div class="line"></div>
      <p>热门服务</p>
      <div class="line"></div>
    </header>
    <div class="service spaceBetween container">
      <div class="card" v-for="item in service">
        <img :src="item.img" alt="">
        <div class="message">
          <h3>{{item.title}}</h3>
          <p class="orange">{{item.price}}</p>
        </div>
      </div>
    </div>
    <header>
      <div class="line"></div>
      <p>一站式采购全程无忧</p>
      <div class="line"></div>
    </header> 
    <div class="rightAway spaceBetween container">
      <div class="card" v-for="item in rightAway">
        <img :src="item.img" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "",
  components: {},
  data() {
    return {
      keyword:'',
      keyArray:[
        {name:'注册',hot:true},
        {name:'无增项装修',hot:true},
        {name:'绿植',hot:false},
        {name:'办公桌',hot:false},
      ],
      navbar:[
        {name:'首页',path:'/waiting',hot:false,new:false},
        {name:'公司注册',path:'/waiting',hot:false,new:false},
        {name:'装修服务',path:'/waiting',hot:true,new:false},
        {name:'办公家具',path:'/waiting',hot:false,new:false},
        {name:'绿植服务',path:'/waiting',hot:false,new:true},
        {name:'电脑整机',path:'/waiting',hot:false,new:false},
        {name:'搬家服务',path:'/waiting',hot:false,new:false},
      ],
      activeMenu:'',
      menubar:[
        {id:1,name:'开办公司',path:'/waiting',icon:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/1.png',select:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/01.png'},
        {id:2,name:'财税代理',path:'/waiting',icon:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/2.png',select:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/02.png'},
        {id:3,name:'法律律师',path:'/waiting',icon:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/3.png',select:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/03.png'},
        {id:4,name:'人事人才',path:'/waiting',icon:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/4.png',select:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/04.png'},
        {id:5,name:'科技服务',path:'/waiting',icon:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/5.png',select:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/05.png'},
        {id:6,name:'设计开发',path:'/waiting',icon:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/6.png',select:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/06.png'},
        {id:7,name:'营销推广',path:'/waiting',icon:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/7.png',select:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/07.png'},
        {id:8,name:'创业支持',path:'/waiting',icon:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/8.png',select:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/08.png'},
      ],
      menuChild:[
        {name:'公司注册',text:['有限公司注册','分公司注册','合伙企业注册','个人独资企业注册','外商独资公司注册','公司注册地址','一般纳税人注册地址','银行开户','创业问诊']},
        {name:'公司变更',text:['公司经营范围变更','公司注册地址变更','法人、高管或注册资本变更','公司股权变更','公司名称变更']},
        {name:'换证注销',text:['公司注销','公司章证遗失补办','五证合一办理','工商年报公示','工商解异常']},
      ],
      banner:[
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/bannersc@2x.png'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/bannersc@2x.png'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/bannersc@2x.png'},
      ],
      profit:[
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/caigoujiage@2x.png',name:'专享采购价'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/kjzp@2x.png',name:'开具增票'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/zght@2x.png',name:'正规合同'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/zsgj@2x.png',name:'专属管家'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/shbz@2x.png',name:'售后保障'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/ljgd@2x.png',name:'了解更多'},
      ],
      special:[
        {title:'企服找智鼎云',text:'高效/省钱/一站式',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/huanb@2x.png'},
        {title:'公装快好省',text:'科学设计/释放30%空间',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/zib@2x.png'},
        {title:'租绿植送养护',text:'成活率100%',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/lanb@2x.png'},
      ],
      service:[
         {title:'公司注册',price:'',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/gszc@2x.png'},
         {title:'租绿植 送养护',price:'15.00元/棵',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/lvzhi@2x.png'},
         {title:'整套家具更省钱',price:'550.00元/套起',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/jiaju@2x.png'},
         {title:'租电脑1台起租零押金',price:'89.00元/台/月',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/zdn@2x.png'},
      ],
      rightAway:[
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/gscs@2x.png'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/qyzx@2x.png'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/bgjj@2x.png'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/rzfw@2x.png'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/bgsb@2x.png'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/fourth/qysh@2x.png'},
      ]
    };
  },
  methods: {
    init() {

    },
    initBanner(){
      var mySwiper = new Swiper(".swiperBig", {
        watchOverflow: true,
        initialSlide: 0, //设定初始化时slide的索引
        direction: "horizontal", //Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)。
        lazy: true,
        speed: 1000, //滑动速度
        grabCursor : true,
        autoplay: {
          // 自动播放
          delay: 5000,
          disableOnInteraction: false
        },
        observer: true,
        observeParents: true
      });
    },
    search(){
      this.$router.push('/waiting')
    },
    menuHover(val){
      this.activeMenu=val.id
    },
    menuLeave(){
      this.activeMenu=''
    }
  },
  mounted() {
    this.initBanner();
  },
  created() {
    this.init();
  },

};
</script>

<style lang='less' scoped>
@import "~style/index";

.searchBox{
  padding:20px 0 24px;
  .search{
    display:flex;
    align-items: center;
    max-width: 1200px;
    margin:0 auto;
    justify-content: center; 
    .input{
      width: 400px;
      display: flex;
      height: 34px;
      align-items: center;
      border:1px solid #FF7A32;
      background: #fff;
      img{
        width:16px;
        margin:0 10px;
      }
      input{
        flex:1;
        outline: none;
        border:none;
        height:32px;
      }
    }
    .btn{
      flex:0 0 80px;
      line-height: 36px;
      height: 36px;
      color:white;
      font-size:18px;
      background: #FF7A32;
      text-align: center;
      cursor: pointer;
    }
  }
  .keyword{
    display: flex;
    justify-content: center;
    margin-top:10px;
    p{
      font-size:14px;
      font-weight:400;
      color:rgba(102,102,102,1);
      margin:0 6px;
    }
  }
}
.shopping{
  background:#EBECF4;
  .container{
    max-width: 1200px;
    margin: 0 auto;
  }
  .navbar{
    width: 100%;
    background: #FF7A32;
    
    .first{
      width: 214px;
      background: #fff;
      justify-content: center;
      height: 40px;
      img{
        width: 22px;
        margin-right:12px;
      }
      p{
        font-size:16px;
        color:rgba(51,51,51,1);
      }
    }
    .navItem{
      position: relative;
      height: 40px;
      p{
        color:white;
        font-size:16px;
        line-height: 40px;
        margin-left:30px;
        cursor: pointer;
      }
      img{
        position:absolute;
        right:0;
        top:0;
        transform:translate(50%,-50%);
        width: 40px;
      }
    }
    .navItem:hover p{
       color:#2C2D41;
    }
  }
  .section{
    .menu{
      height: 475px;
      display: flex;
      margin-right:10px;
      flex-direction: column;
      background: #2C2D41;
      position: relative;
      .menuItem{
        display: flex;
        align-items: center;
        padding:0 20px;
        width: 214px;
        box-sizing: border-box;
        flex:1;
        .icon{
          width: 18px;
          margin-right:12px;
        }
        p{
          flex:1;
          font-size:16px;
          color:white;
        }
        .more{
          width: 7px;
          
        }
      }
      &:hover .childmenu{
        display: block;
      }
      .childmenu{
        z-index: 100;
        display: none;
        position: absolute;
        right:0;
        top:0;
        transform: translateX(100%);
        width: 550px;
        padding:0 20px;
        background: #2C2D41;
        border-left:1px solid #999;
        border-top:1px solid #999;
        .childItem{
          display: flex;
          border-bottom:1px solid #999999;
          padding:10px 0;
          .title{
            flex:0 0 20%; 
            color:white;
            padding-top:10px;
          }
          .content{
            span{
              color:white;
              display: inline-block;
              line-height: 40px;
              margin-right:10px;
            }
            span:hover{
              color:#FF7A32;
              cursor: pointer;
            }
          }
        }
        .childItem:last-child{
          border:0;
        }
      }
    }
    .user{
      flex:0 0 276px;
      margin-left:10px;
      height: 475px;
      background: #fff;
      h3{
        font-size:16px;
        color:rgba(51,51,51,1);
      }
      p{
        font-size:14px;
        color:rgba(153,153,153,1);
      }
      .box{
        padding:15px 20px;
      }
      .top{
        .avatar{
          flex:0 0 44px;
          height: 44px;
        }
        .login{
          height:30px;
          margin-top:20px;
          background:rgba(255,122,50,1);
          border-radius:4px;
          width: 100%;
          line-height: 30px;
          color:white;
          text-align: center;
        } 
      }
      .bottom{
        .spaceBetween{
          flex-wrap: wrap;
          .item{
            flex:30%;
            margin:10px 0;
            text-align: center;
            img{
              width: 34px;
            }
          }
        }
      }
    }
  }
}
.swiperBig{
  height:475px;
}
header{
  max-width: 1200px;
  display: flex;
  align-items: center;
  margin:20px auto;
  .line{
    background: #999999;
    height: 2px;
    flex:1;
  }
  p{
    font-size:18px;
    margin:0 10%;
    font-weight:bold;
    color:rgba(51,51,51,1);
  }
}
.intro{
  .card{
    position: relative;
    img{
      width: auto;
      height: 150px;
    }
    .message{
      position: absolute;
      top:50%;
      transform: translate(-50%,-50%);
      width: 80%;
      left:50%;
      color:white;
      h3{
        font-size:26px;
        font-weight:bold;
        color:rgba(245,245,245,1);
      }
      .line{
        width: 30px;
        height: 2px;
        background: #fff;
        margin:10px 0;
      }
      p{
        font-size:16px;
        font-weight:400;
      }
    }
  }
}
.service{
  .card{
    position: relative;
    img{
      height: 150px;
      width: auto;
    }
    .message{
      position: absolute;
      top:20%;
      width: 80%;
      left:10%;
      color: #333333;
      h3{
        font-size:22px;
        font-weight:bold;
      }
      p{
        font-size:16px;
        font-weight:400;
      }
    }
  }
}
.rightAway{
  padding-bottom:20px;
  .card{
    margin-right: 10px;
    flex:1;
    
  }
}
</style>